import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './FinancialTableHeader.style';

const FinancialTableHeader = ({ children, className, subHeader, ...other }) => {
  const headerClass = subHeader ? styles.subHeader : styles.header;
  return (
    <Text
      as="p"
      variant="large"
      block
      className={clsx(styles.root, headerClass, className)}
      {...other}
    >
      {children}
    </Text>
  );
};

FinancialTableHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  subHeader: PropTypes.bool,
};

FinancialTableHeader.defaultProps = {
  className: '',
  subHeader: false,
};

export default FinancialTableHeader;
